<template>
  <div class="row">
    <div class="col-12 col-lg-8 g">
      <div class="card">
        <div class="card-header">
          <div>
            <h4 class="mb-25">
              <i class="fa fa-youtube-play"></i>
              فيديو شرح التطبيقات
            </h4>
            <span class="text-muted">رابط الفيديو الذي يفتحه زر «شرح استخدام التطبيق» في التطبيقات الجديدة. اترك الرابط فارغاً ليختفي الزر من التطبيق.</span>
          </div>
        </div>
        <div class="card-body">
          <div v-for="a in apps" :key="a.key" class="form-group">
            <label :for="'tutorial-' + a.key">{{ a.name }}</label>
            <div class="input-group">
              <input :id="'tutorial-' + a.key" class="form-control" dir="ltr" maxlength="500" placeholder="https://www.youtube.com/watch?v=..." v-model.trim="links[a.key]">
              <div class="input-group-append">
                <a class="btn btn-outline-primary" :class="{ disabled: !canOpen(links[a.key]) }" :href="canOpen(links[a.key]) ? links[a.key] : null" target="_blank" rel="noopener" title="تجربة الرابط">
                  <i class="fa fa-external-link"></i> فتح
                </a>
              </div>
            </div>
            <small v-if="links[a.key] && !valid(links[a.key])" class="text-danger d-block mt-25">الرابط غير صحيح، اكتبه كاملاً يبدأ بـ https://</small>
            <small v-else-if="links[a.key]" class="text-muted d-block mt-25">يظهر الزر في: {{ a.where }}</small>
            <small v-else class="text-muted d-block mt-25">بدون رابط: الزر مخفي في هذا التطبيق.</small>
          </div>
          <button class="btn btn-primary" @click="save()" :disabled="saving || !loaded">
            <i class="fa fa-save"></i>
            {{ saving ? 'جاري الحفظ...' : 'حفظ' }}
          </button>
          <p class="text-muted mt-1 mb-0">يظهر التغيير في التطبيقات خلال دقيقة تقريباً، وفقط في إصدارات التطبيقات التي فيها هذا الزر.</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      jwt: localStorage.getItem('jwt'),
      links: { parent: '', teacher: '', school: '' },
      loaded: false,
      saving: false,
      apps: [
        { key: 'parent', name: 'تطبيق ولي الأمر', where: 'شاشة اختيار اللغة (أول فتح للتطبيق)، والإعدادات تحت «الوضع الداكن»' },
        { key: 'teacher', name: 'تطبيق المعلم', where: 'شاشة تسجيل الدخول، وصفحة «حسابي»' },
        { key: 'school', name: 'تطبيق المدرسة', where: 'شاشة تسجيل الدخول، والإعدادات في قسم «الدعم»' },
      ],
    };
  },
  created() {
    this.load();
  },
  methods: {
    // Same rule as the server (src/app_tutorials.js): empty, or an http(s) link up to 500 characters.
    valid(link) {
      return !link || (link.length <= 500 && /^https?:\/\/\S+$/i.test(link));
    },
    canOpen(link) {
      return !!link && this.valid(link);
    },
    load() {
      var g = this;
      $.post(api + '/admin/apps/tutorials', { jwt: this.jwt }).then(function(r){
        if(r.status != 100) return alert(r.response, 200);
        g.links = Object.assign({ parent: '', teacher: '', school: '' }, r.response);
        g.loaded = true;
      });
    },
    save() {
      var g = this;
      var bad = this.apps.find(function(a){ return !g.valid(g.links[a.key]); });
      if(bad) return alert('رابط ' + bad.name + ' غير صحيح، اكتبه كاملاً يبدأ بـ https://', 200);
      g.saving = true;
      $.post(api + '/admin/apps/tutorials/save', {
        jwt: this.jwt,
        parent: this.links.parent,
        teacher: this.links.teacher,
        school: this.links.school,
      }).then(function(r){
        g.saving = false;
        if(r.status != 100) return alert(r.response, 200);
        g.links = Object.assign({ parent: '', teacher: '', school: '' }, r.response);
        alert('تم الحفظ، يظهر في التطبيقات خلال دقيقة تقريباً.', 100);
      }).fail(function(){
        g.saving = false;
        alert('تعذر الاتصال بالسيرفر', 200);
      });
    },
  },
};
</script>

<style scoped>
.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.input-group-append .btn {
  white-space: nowrap;
}
</style>
